/* eslint-disable no-unused-vars */
import { useForm, Controller } from 'react-hook-form';
import { CustomInput, Buttons } from 'components';
import * as S from './PublisherPayments.styled';

export const PayPalForm = ({
  userEmail,
  currentPayPalEmail,
  onSetIsPayPalOpen,
  onHandleSavePayments,
  isButtonDisabled,
}) => {
  const {
    handleSubmit,
    control,
    trigger,
    clearErrors,
    formState: { isValid, isSubmitting },
    watch,
  } = useForm({
    mode: 'onChange',
    shouldFocusError: false,
  });

  const currentEmail = watch('email');

  function onSubmit(data) {
    onHandleSavePayments(data, 2);
  }

  return (
    <S.StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name='email'
        control={control}
        defaultValue={currentPayPalEmail || ''}
        rules={{
          required: 'Email is required',
          pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: 'Please enter a valid email address',
          },
        }}
        render={(props) => {
          const { field, formState, fieldState } = props;
          return (
            <CustomInput
              type='email'
              name='email'
              onFocus={() => clearErrors('email')}
              onBlur={() => trigger('email')}
              onChange={field.onChange}
              placeholder={currentPayPalEmail || userEmail}
              error={fieldState.invalid}
              value={field.value || ''}
              id='paypalEmail'
              containerStyle={{ marginBottom: '16px' }}
              inputStyle={{ fontSize: '14px' }}
            />
          );
        }}
      />
      <S.ButtonsWrap>
        <Buttons.SecondaryNormal
          id='canсel_wire'
          type='reset'
          onClick={() => onSetIsPayPalOpen(false)}
        >
          Canсel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id='save_wire'
          type='submit'
          isDisabled={
            isButtonDisabled || currentPayPalEmail === currentEmail || !isValid || isSubmitting
          }
        >
          Save
        </Buttons.PrimaryNormal>
      </S.ButtonsWrap>
    </S.StyledForm>
  );
};
